// @flow
import React, { Component } from 'react';
import OrderInvoiceTemplateContainer from 'containers/order/OrderInvoiceTemplateContainer';

type Props = {};

class OrderInvoice extends Component<Props> {
  render() {
    return <OrderInvoiceTemplateContainer />;
  }
}

export default OrderInvoice;



// WEBPACK FOOTER //
// ./src/pages/OrderInvoice.js